<template>
  <div class="check-list-delete auto-list_col_centered">
    <div class="icons-wrap">
      <img v-if="item.length" src="@/assets/img/edc.svg" alt="" />
      <img
        v-if="iconIsMustShow"
        :class="classObject"
        src="@/assets/img/verification-man.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { checkFailStatuses } from './statusDescription'

const EDS = RepositoryFactory.get('contragents')

export default {
  name: 'AccreditationListsIcon',
  props: {
    approveData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      item: '',
      loaded: false,
    }
  },
  computed: {
    classObject() {
      return {
        not_verified: this.approveIsDeny(),
      }
    },
    iconIsMustShow() {
      return (
        this.masterApproveIsNotNull() && [1, 2, 3].includes(this.getStatusId())
      )
    },
    load() {
      return this.loaded
    },
  },
  created() {
    const { user_org_inn, organization } = this.approveData || {}
    const inn = user_org_inn || organization?.inn

    if (this.isAdminOrCeoRole && inn) {
      EDS.getEDC(inn)
        .then(response => {
          this.item = response.data
          this.loaded = true
        })
        .catch(e => this.errHandler(e))
    }
  },
  methods: {
    approveIsDeny() {
      return checkFailStatuses(this.getStatusId())
    },
    getStatusId() {
      return this.approveData['master-approve'].status
    },
    masterApproveIsNotNull() {
      return (
        Object.prototype.hasOwnProperty.call(
          this.approveData,
          'master-approve',
        ) &&
        this.approveData['master-approve'] &&
        'status' in this.approveData['master-approve']
      )
    },
  },
}
</script>

<style lang="sass" scoped>
.icons-wrap
    display: flex
    align-items: center
    justify-content: center
.not_verified
    filter: invert(40%) grayscale(100%) brightness(55%) sepia(100%) hue-rotate(-50deg) saturate(400%) contrast(2);
</style>
